.bam-session-timeout__notification-wrapper{
    position: sticky;
    top: 0;
    z-index: 1000;
}